export default "__VITE_ASSET__ADeV9lmT__"